module.exports = __webpack_public_path__ + "media/fallback/FAFSA-available-annually-9bf42cca.png";